export default __webpack_public_path__ + "static/media/21-get promoted.cff34035.svg";